"use client";
import { Tab } from "@mui/material";
import { styled } from "@mui/material/styles";
import { ColorBlue100, FontWeightBold, ColorTextDefault, SpaceXs, SpaceXxs, FontWeightDefault, FontSize200, RadiusMd } from "@nxt-costco-com/forge-design-tokens";
const StyledTab = styled(Tab, {
  shouldForwardProp: (prop) => prop !== "isLastTab"
})((props) => {
  return {
    borderRadius: `${RadiusMd} ${RadiusMd} 0px 0px`,
    color: ColorTextDefault,
    fontSize: FontSize200,
    fontWeight: FontWeightDefault,
    marginRight: props.isLastTab ? SpaceXs : "0px",
    minHeight: "33px",
    minWidth: "60px",
    padding: `${SpaceXs} ${SpaceXs} ${SpaceXxs} ${SpaceXs}`,
    textTransform: "none",
    "&::after": {
      content: "attr(data-text)",
      fontWeight: FontWeightBold,
      height: 0,
      overflow: "hidden",
      pointerEvents: "none",
      userSelect: "none",
      visibility: "hidden",
      "aria-hidden": "true",
      "@media speech": {
        display: "none"
      }
    },
    "&:hover": {
      backgroundColor: ColorBlue100,
      color: ColorTextDefault,
      fontWeight: FontWeightBold
    },
    "&.Mui-selected": {
      backgroundColor: ColorBlue100,
      color: ColorTextDefault,
      fontWeight: FontWeightBold
    },
    "&.Mui-focusVisible": {
      backgroundColor: ColorBlue100,
      outlineOffset: "-2px",
      outline: "2px solid -webkit-focus-ring-color"
    }
  };
});
export {
  StyledTab
};
